/* A set of two shapes, transPath and the Icon over it -- the base/'proto' from which the others extend */

var RaphaelView = require('raphaelItemView'),
    Raphael = require('raphael'),
    $ = require('jquery'),
    _ = require('underscore');

require('extendRaphael');
require('fontello');

var ICON_FONT = 'fontello';

var instVars = {
    isActive: false, //for hover -- todo: only used for redaction : means when the redactProp is open -- move there ( and i guess now sign. dialog)
    parent: null, //todo: may not be necessary anymore if pass in derivations
    pgNoteModel: null, //TODO: PUT just IN REDACTION? -- only used there ?
    //sub r elements
    icon: null,
    transparentPath: null,
    //currently derived from parent
        paper: null,
        shapeModel: null
    //currently on proto of derivitives
        //this.iconCode, this.title, iconMouseOverColor, color, clickAction, topOffset
};

module.exports = RaphaelView.extend({ //note the delete extended
    scale: 1.2,   //want a little larger than the font
    iconMouseOverColor: '#0F3CFF',
    initialize: function(options) {
        _.extend(this, instVars, _.pick(options, 'parent', 'pgNoteModel'), {
            paper: options.parent.paper,
            shapeModel: options.parent.shapeModel
        });
        if (!Raphael.fonts[ICON_FONT]) this.paper.getFont(ICON_FONT);
        return this;
    },
    render: function() {
        this.icon = this._drawIcon();
        this.transparentPath = this._drawTransparentPath( this.icon.getBBox() );
        // using the node and click fn fixes bug in IE* below -- don't really need now .. (still need?)
        $(this.transparentPath.node).on( 'click', _.bind( function(e) {
            this.clickAction(e);
        }, this) );

        var el = this.paper.set(this.icon, this.transparentPath)
            .data('shapeType', 'button'); //todo *C
        this.setElement(el);
        this.delegateHover();
        return this;
    },
    _drawIcon: function() {
        return this.paper.print(
            this.options.x, this.options.y,
            String.fromCharCode(this.iconCode), /* note: designed to be used in deriving classes */
            ICON_FONT
        ).attr({
            fill: this.color,
            stroke: 'none',
            cursor: 'pointer',
            'stroke-width': 0,
            transform: 'S' + this.scale
        }).bakeTransform();
    },
    _drawTransparentPath: function(iconBox) {
        return this.paper.rect(
            iconBox.x,
            iconBox.y,
            iconBox.width,
            iconBox.height
        ).attr({
            opacity: 0,
            cursor: 'pointer',
            stroke: 'none',  //OPACITY 0 MAKES POSSIBLE
            fill: this.color,
            title: this.title
        });
    },
    getIcon: function() {
      return this.icon;
    },
    getTransparentPathEl: function() {
      return this.transparentPath.node;
    },
    /* !THIS IS THE FIX FOR IE LESS THAN 8 AND DISAPPEAR BTN ON HOVER */
    delegateHover: function() {
        this.transparentPath
            .mouseover(function() {
                return false;
            }).mouseout(function() {
                return false;
            });
        this.el.mouseover( _.bind( function(e) { this.mouseover(e); }, this));
        this.el.mouseout( _.bind( function(e) { this.mouseout(e); }, this));
    },
    mouseover: function() {
        if (!this.isActive) this.icon.stop().animate({fill: this.iconMouseOverColor} , 150);
    },
    mouseout: function() {
        if (!this.isActive) this.icon.stop().animate({fill: this.color} , 150);
    },
    clickAction: $.noop,
    destroy: function() {
        $(this.transparentPath.node).off('click');
        this.el.unmouseover().unmouseout(); //undelegate hover
        this.transparentPath.remove();
        this.icon.remove();
        this.el.remove();
        this.remove();
    }
});



/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/canvas/views/shape/selectSet/btn/shapeButton.js
 ** module id = 209
 ** module chunks = 0
 **/